/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whole_Plain_Mantis_AffirmInputs */

const en_whole_plain_mantis_affirm = /** @type {(inputs: Whole_Plain_Mantis_AffirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short Token`)
};

/**
* | output |
* | --- |
* | "Short Token" |
*
* @param {Whole_Plain_Mantis_AffirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const whole_plain_mantis_affirm = /** @type {((inputs?: Whole_Plain_Mantis_AffirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whole_Plain_Mantis_AffirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_whole_plain_mantis_affirm(inputs)
});